module.exports = __webpack_public_path__ + "img/block6-card3.b78f5e8c.svg";